import { useEffect } from "react";
import { Route } from "react-router-dom";

import Loading from "src/components/Loading";
import { EndSession } from "src/components/SessionGate";
import { APPLINK } from "./config";

const isOnboardingApproved = (user) => {
  return user.data.onboardingStep === "DONE" && user.data.isApproved === true;
};

/* Onboarding lives on the webapp. The page behind this route is not drawn on
   the way there: its requests would be refused for a client not yet approved,
   and a refused request now ends the session, which would send them to sign
   in instead. */
const GoToOnboarding = () => {
  useEffect(() => {
    window.location.href = `${APPLINK}/onboarding`;
  }, []);
  return <Loading />;
};

/**
 * A page for signed-in clients only.
 *
 * SessionGate already keeps the whole app back until there is a session, so
 * this rarely sees anyone without one. When it does, it ends the session like
 * everywhere else — the cookie cleared, then the webapp's login page — rather
 * than sending the browser to log in with the cookie still set, which the
 * webapp answers by sending it straight back here. While /me is loading it
 * shows the loading mark rather than rendering nothing.
 */
const PrivateRoute = ({ user, children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        if (user.isLoading && !user.data) return <Loading />;
        if (!user.isAuthenticated) return <EndSession />;
        if (!isOnboardingApproved(user)) return <GoToOnboarding />;
        return children;
      }}
    />
  );
};

export default PrivateRoute;
